(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbDocumentIndexDataStore', [
			'$q',
			'smbIndexTypesDataTypes',
			'smbIndexTypesService',
			DocumentIndexDataStore
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentIndexDataStore
	 *
	 * @description
	 * Service for managing index values for a single document
	 */
	function DocumentIndexDataStore($q, smbIndexTypesDataTypes, smbIndexTypesService) {

		var _indexTypes;
		var _indexValues;
		var _documentId;
		var _contentTypeId;

		return {

			get indexTypes() { return _indexTypes; },
			get indexValues() { return _indexValues; },

			get indexTypePanelModel() {
				return _indexTypes.map(function(indexType) {
					var val = _indexValues.find(function(iv) { return iv.TagTypeName === indexType.TagTypeName; });
					var temp = angular.extend({}, indexType);
					if (val && val.Tags && val.Tags.length > 0) {
						temp.defaultValue = val.Tags[0];
					}

					if (temp.DataType === smbIndexTypesDataTypes.NUMERIC) {
						temp.defaultValue = parseFloat(temp.defaultValue);
					}

					return temp;
				});
			},

			getIndexes: getIndexes

		};

		function getIndexes(documentId, contentTypeId, useCached) {
			if (canUseCached(documentId, contentTypeId, useCached)) {
				return $q.resolve(_indexValues);
			} else {
				return smbIndexTypesService.getIndexTypes(contentTypeId)
					.then(function(types) {
						_indexTypes = types.filter(function(tt) {
							return !(tt.TagTypeName.match(/&&_AirBase_.*/));
						});
						_contentTypeId = contentTypeId;
						return smbIndexTypesService.getDocumentIndexes(documentId);
					})
					.then(function(data) {
						_documentId = documentId;
						_indexValues = [];

						var sequence = 0;

						_indexValues = data.TypedTags.filter(function(tt) {
							return !(tt.TagTypeName.match(/&&_AirBase_.*/));
						})
						.map(function(tt) {
							var val = tt.Tags[0];
							var indexType = _indexTypes.find(function(it) { return it.TagTypeName === tt.TagTypeName; });

							if (indexType && indexType.DataType === smbIndexTypesDataTypes.NUMERIC && val) {
								tt.Tags[0] = toNumber(val);
								tt.isNumber = true;
							} else if (indexType && indexType.DataType === smbIndexTypesDataTypes.DATE && val) {
								tt.Tags[0] = toDate(val);
								tt.isDate = true;
							}

							var i = _indexTypes.indexOf(indexType);
							if (i < 0) {
								i = sequence;
							}

							tt.sequence = i;
							sequence++;
							return tt;
						});
						return _indexValues;
					});
			}
		}

		function canUseCached(documentId, contentTypeId, useCached) {
			return useCached && documentId === _documentId && contentTypeId === _contentTypeId &&
				_indexTypes && _indexValues;
		}

		function toNumber(val) {
			if (!val && typeof val !== 'number') {
				return;
			}

			var num = parseFloat(val);
			return isNaN(num) ? undefined : num;
		}

		function toDate(val) {
			if (!val) {
				return;
			}

			var m = parseInt(val.substr(0, 2));
			var d = parseInt(val.substr(2, 2));
			var y = parseInt(val.substr(4));

			return new Date(y, m - 1, d);
		}
	}
	
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/documentIndexDataStore.js
// module id = 122
// module chunks = 1